<div class="tag-container">
  <ng-container *ngIf="features">
    <div *ngFor="let feature of features; let i = index">
      <div
        *ngIf="feature?.active || feature?.customizedStudents > 0"
        class="activity-tag tabText active-features"
        [ngClass]="{
          'tag--m-bottom': allActivedFeatures && i === 0,
          'tag--m-top': allActivedFeatures && i === features.length - 1 && features.length > MAX_FEATURES_INLINE
        }"
        translate>
        {{ feature?.title }}
        <svg-icon
          *ngIf="feature.amountCustom > 0 && feature.amountCustom < feature.customizedStudents?.length && isTeacher"
          key="ic-user"></svg-icon>
      </div>
    </div>
  </ng-container>
  <!--correctStatus to handle ActivityStatus.TRIES, status not defined in design -->
  <div *ngIf="status !== undefined && status !== null && correctStatus && isVisibleStatus; else noTag" class="activity-tag tabText" [ngClass]="statusStyle">
    {{ 'f.tags.status.' + (status === 3?0:status) | translate }}
  </div>
</div>
<ng-template #noTag>
  <div *ngIf="isTeacher && !features?.length" class="activity-tag tabText"></div>
</ng-template>
